import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import 'video.js/dist/video-js.css';
import videojs from 'video.js';

class AudioPlayback extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.videoJsOptions = {
      controls: true,
      height: 150,
      fluid: false
    };
  }

  render() {
      return (
          <video
              id="PlayAudio"
              className="video-js vjs-default-skin"
              controls
              data-setup='{}'>
            <source src={this.props.s3_url} type="audio/mp3"></source>
            <p className="vjs-no-js">
              To listen to this audio please enable JavaScript, and consider upgrading to a
              web browser that
              <a
                href="https://videojs.com/html5-video-support/"
                target="_blank"
                rel="noreferrer"
              >
                supports HTML5 audio
              </a>
            </p>
          </video>
      );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { }
)(AudioPlayback);
